import { IEmployeesStore } from './index'

export default {
  employees: [],
  emailError: '',
  tab: 0,
  editEmployee: null,
  loading: false,
} as IEmployeesStore
